import { Navigate } from 'react-router';

import type { ReactNode } from 'react';

import { useCurrentUser, useSelectIsGetCurrentUserInfoLoading } from '@treneo/features/user';
import { urls } from '@treneo/shared/constants';
import { useAppTranslations } from '@treneo/shared/i18n';
import { useAppParams } from '@treneo/shared/router';
import { Box, Spinner, Typography } from '@treneo/shared/ui';

type Props = Readonly<{
  permissionCode: string;
  children: ReactNode;
}>;

export const RequireOrganizationPermission = ({ permissionCode, children }: Props) => {
  const { t } = useAppTranslations();
  const { organizationId } = useAppParams<{ organizationId: string }>();
  const { hasPermission } = useCurrentUser();
  const isGetCurrentUserInfoLoading = useSelectIsGetCurrentUserInfoLoading();

  if (isGetCurrentUserInfoLoading) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' minHeight='400px'>
        <Box display='flex' alignItems='center' gap={2}>
          <Spinner />
          <Typography>{t('checkingPermissions')}</Typography>
        </Box>
      </Box>
    );
  }

  if (!organizationId) {
    return <Navigate to={urls.homePage} replace />;
  }

  if (!hasPermission(permissionCode, organizationId)) {
    return <Navigate to={urls.homePage} replace />;
  }

  return <>{children}</>;
};
